import type { JSX } from 'react';
import i18n from '@app/i18n';
import { transformBoolean } from '@app/utils';

type CriteriaAnswerType = {
  maxThreshold?: number | null;
  minThreshold?: number | null;
  otherValues?: string[] | null;
  unit?: string | null;
  value?: boolean | null;
};

export const createExpectedAnswer = (criteria: CriteriaAnswerType): JSX.Element | null => {
  if (criteria.minThreshold !== null && criteria.maxThreshold !== null) {
    return (
      <>{`≥ ${criteria.minThreshold} ${i18n.t('common.and')} ≤ ${criteria.maxThreshold} ${
        criteria.unit || ''
      }`}</>
    );
  }

  if (criteria.minThreshold === null && criteria.maxThreshold !== null) {
    return <>{`≤ ${criteria.maxThreshold} ${criteria.unit || ''}`}</>;
  }
  if (criteria.minThreshold !== null && criteria.maxThreshold === null) {
    return <>{`≥ ${criteria.minThreshold} ${criteria.unit || ''}`}</>;
  }

  if (typeof criteria.value === 'boolean') {
    return <>{transformBoolean(String(criteria.value))}</>;
  }

  if (criteria.otherValues?.length) {
    return <>{criteria.otherValues.join(', ')}</>;
  }
  return <div>{i18n.t('common.missing_value')}</div>;
};
